// Cadastro de notificações Web Push (mobile) — complementa o SSE: o SSE só
// atualiza a tela enquanto o app está aberto, o push avisa mesmo com o app
// fechado/em segundo plano (ex: garçom com o celular no bolso).
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function suportado() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

// Registra o service worker, pede permissão de notificação e inscreve o
// dispositivo — `papel` é 'equipe' (cozinha/garçom/admin, recebe eventos do
// estabelecimento) ou 'cliente' (recebe só os próprios pedidos).
export async function inscreverPush({ papel, idEstabelecimento, idCliente }) {
  if (!suportado()) {
    console.warn('⚠️ [Push] Navegador não suporta notificações push.');
    return false;
  }

  const publicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
  if (!publicKey) {
    console.warn('⚠️ [Push] REACT_APP_VAPID_PUBLIC_KEY não configurada.');
    return false;
  }

  try {
    const permissao = await Notification.requestPermission();
    if (permissao !== 'granted') {
      console.log('🔕 [Push] Permissão de notificação negada.');
      return false;
    }

    const registration = await navigator.serviceWorker.register('/service-worker.js');
    await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      });
    }

    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/push/inscrever`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({
        subscription,
        papel,
        id_estabelecimento: idEstabelecimento || null,
        id_cliente: idCliente || null
      })
    });

    if (!response.ok) {
      console.error('❌ [Push] Backend recusou a inscrição:', await response.text());
      return false;
    }

    console.log(`✅ [Push] Inscrição push registrada (${papel}).`);
    return true;
  } catch (error) {
    console.error('❌ [Push] Erro ao inscrever push:', error);
    return false;
  }
}

// Remove a inscrição deste dispositivo (ex: no logout).
export async function desinscreverPush() {
  if (!suportado()) return;

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager.getSubscription();
    if (!subscription) return;

    const token = localStorage.getItem('token');
    await fetch(`${API_URL}/push/desinscrever`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ endpoint: subscription.endpoint })
    });

    await subscription.unsubscribe();
  } catch (error) {
    console.error('❌ [Push] Erro ao desinscrever push:', error);
  }
}
